export default __webpack_public_path__ + "static/media/landingAll.e879ad3b.PNG";